package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetClubKeywordResponse(
    val data: List<KeywordsUsageData> ,
)
@Serializable
data class GetClubKeywordData(
    val key: List<String> ? = null,
    val value: Value ? = null,
)
@Serializable
data class Value(
    val count: Int=0,
    val keywordCategory: String? = null,
    @SerialName("sessionID")
    val sessionId: String? = null,
    val text: String? = null
)

@Serializable
data class KeywordsUsageData(
    val text: String,
    val keywordCategory: String,
    val language: String,
    val usageCount: Int,
)
